const userAgent = typeof navigator === 'undefined' ? '' : navigator.userAgent;

export const isMobile =
  /android|webos|iphone|ipod|ipad|blackberry|iemobile|opera mini|windows phone|mobile|tablet|silk|kindle|playbook/i.test(
    userAgent,
  );

export default isMobile;
